import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import { Dashboard } from "../screens";
import { DashboardSwitcher } from "./components";
import { Layout, ScreenHeading } from "../webtracking/components";
import { AverageLeadTime, Efficiency, PartStatus } from "./screens";

const DashboardRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Layout>
      <ScreenHeading title="Reportes">
        <DashboardSwitcher />
      </ScreenHeading>
      <Switch>
        <Route path={`${path}/average_eta`}>
          <AverageLeadTime />
        </Route>
        <Route path={`${path}/part_status`}>
          <PartStatus />
        </Route>
        <Route path={`${path}/catering`}>
          <Dashboard />
        </Route>
        <Route path={`${path}`}>
          <Efficiency />
        </Route>
      </Switch>
    </Layout>
  );
};

export default DashboardRouter;
